import React from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';

import '../../css/DropZone.css';

var DropZone = React.createClass({
    styles: {
        uploadContainerHover: {
            borderStyle: "dashed",
            borderColor: "black",
            borderWidth: "2px",
            borderRadius: "10px",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            background: "white",
        },
        dropHelperTitle: {
            textAlign: "center",
            color: "black",
            fontStyle: "italic",
        },
        dropHelperIcon: {
            textAlign: "center",
            marginTop: "10px",
        }
    },
    getInitialState: function() {
        return {
            hovering: 0,
            showDialog: false
        };
    },
    onDragEnter: function(event) {
        // console.log("onDragEnter");
        this.setState({...this.state, hovering:this.state.hovering + 1});
    },
    onDragOver: function(event) {
        event.preventDefault();
        return true;
    },
    onDragLeave: function(event) {
        // console.log("onDragLeave");
        this.setState({...this.state, hovering:this.state.hovering - 1});
    },
    onDrop: function(event) {
        // console.log(event.dataTransfer);
        event.preventDefault();
        this.setState({...this.state, hovering:0});

        var droppedFiles = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        var file = droppedFiles[0];

        if (this.isAcceptableFile(file)) {
            this.props.onDrop(file);
        } else {
            this.setState({...this.state, showDialog:true});
        }
    },
    isAcceptableFile: function(file) {
        if (this.props.accepts) {
            var accepts = this.props.accepts.split(",");
            var parts = file.name.split(".");
            for (var index = 0; index < accepts.length; index++) {
                if (accepts[index].toLowerCase() === parts[parts.length-1].toLowerCase()) {
                    return true;
                }
            }
            return false;
        }
        return true;
    },
    handleCloseDialog: function() {
        this.setState({...this.state, showDialog:false, hovering:0});
    },
    render: function() {
        var uploadingContent = <div style={{textAlign: "center"}}>
                <div className="drop-zone-title" style={{marginBottom: "20px"}}>Uploading</div>
                <CircularProgress size={50} />
            </div>;
        var dropHelperContent = <div>
                <div className="drop-zone-title">You got this!</div>
                <div className="drop-zone-or">
                    Placeholder
                </div>
            </div>;

        var content = this.props.emptyContent;
        if (this.state.hovering) {
            content = dropHelperContent;
        } else if (this.props.uploading) {
            content = this.props.uploadingContent ? this.props.uploadingContent : uploadingContent;
        } else if (this.props.hasMedia) {
            content = this.props.mediaContent;
        }

        return (
            <div className={this.state.hovering ? "drop-zone-upload-container" : "drop-zone-upload-container"}
                onDragEnter={this.onDragEnter}
                onDragOver={this.onDragOver}
                onDragLeave={this.onDragLeave}
                onDrop={this.onDrop}>
                <div style={{padding:"20px", display:"flex", flexGrow:"1", alignItems:"center", justifyContent:"center", height:"100%"}}>
                    {content}
                </div>
                <Dialog
                    open={this.state.showDialog}
                    actions={[
                      <FlatButton label="OK" primary={true} onTouchTap={this.handleCloseDialog} />
                    ]}
                    title="Invalid Filetype"
                    onRequestClose={this.handleCloseDialog}>
                    You can only upload these filetypes: {this.props.accepts}
                </Dialog>
            </div>
        );
    }
});

export default DropZone;



// WEBPACK FOOTER //
// ./src/components/common/DropZone.js